export const ACCESS_TOKEN = 'access-token' // token
export const USER_INFO = 'user-info'
export const MENU_NAME = 'user-menu'
export const COMPONENTS_NAME = 'user-components'
export const INDEX_PATH = '/home' // 主页路径
// /xwzy/* ， 给行稳致远添加页面路劲白名单
export const WHITE_PATHS = ['/loginPage', '/xwzy/articleDetails', '/sso/tempPage', '/register', '/followPage', '/xwzy/trainDetails', '/xwzy/AIFV', '/xwzy/department', '/xwzy/journeyReport', '/courserDetailsXwzy', '/AIFVONEPAGE', '/longTimeLogin', '/fontBase', '/agreeDetailPage', '/linkExpired'] // 白名单路径，在没有token时可以进入的页面
export const WHITE_PATHS_BY_EMAILTOKEN = ['/courserDetailsXwzy', '/xwzy/articleDetails', '/xwzy/AIFV', '/AIFVONEPAGE'] // 白名单路径，在没有token时可以进入的页面
// 白名单路径-自定义分享
export const WHITE_PATHS_BY_SHARE = ['/courserDetails', '/technologyDetail', '/articleDetails', '/journalArticle', '/liveDetails', '/filePreview']
// 白名单路径-自定义分享-首次进入埋点
export const WHITE_PATHS_BY_SHARE_INIT = ['/courserDetails', '/journalArticle', '/liveDetails']
// 白名单路径-自定义分享-首次进入埋点（entrance=168：ieP关注自动回复内容）
export const WHITE_PATHS_BY_SHARE_INIT_168 = ['/pfa2', '/technologyIndex']
// 白名单路径-自定义分享-二维码扫码轮询（entrance=180）
export const WHITE_PATHS_BY_SHARE_INIT_180 = ['/liveDetails']

// 对cj内的页面做全局拦截, 如果是分享出去的这些页面, 直接强制跳转到, cj日历入口页, 防止分享出去后, 引发权限问题
export const cjInterceptPath = [
  '/surgeonList',
  '/selectiveDisease',
  '/selectiveTechnique',
  '/journeyPage',
  '/selectActivity',
  '/journeyEdit',
  '/selectCourse'
]

// 给分享添加自定义
export const SHARE_PATH = [
  '/JJMC_ECGenius',
  '/questionnaire',
  '/kdSimulator',
  '/technologyDetail',
  '/dailyDetails',
  '/scormCourseDetail',
  '/courserDetails',
  '/trainDetails',
  '/disease',
  '/subject',
  '/errDisease',
  '/errSubject',
  '/colDisease',
  '/colSubject',
  '/questionResult',
  '/questionDetails',
  '/dccDetail',
  '/zoneDetails',
  '/train_ques',
  '/trainCourse',
  '/trainingDetail',
  '/gradeHomePage',
  '/topicDetail',
  '/answerDetails',
  '/iepDetails',
  '/mockDetails',
  '/journeyPage',
  '/articleDetails',
  '/annualReport',
  '/dxy',
  '/journalArticle',
  '/pfa2',
  '/laac',
  '/filePreview',
]



// WEBPACK FOOTER //
// ./src/store/mutation-types.js